import React, { Component, Fragment } from "react";

// Externals
import classNames from "classnames";

import PropTypes from "prop-types";

// Material helpers
import { withStyles } from "@material-ui/core";

// Material components
import { IconButton, Grid, Toolbar, Menu, MenuItem } from "@material-ui/core";

// Material icons
import {
  Menu as MenuIcon,
  Input as InputIcon,
  PermIdentity as UserIcon,
  Settings as SettingsIcon,
} from "@material-ui/icons";

import logo from "../pictures/logo_transparent.png";

// Component styles
import { HeaderStyles } from "../styles/";

class Topbar extends Component {
  state = {
    anchorEl: null,
  };
  render() {
    const { classes, className } = this.props;

    const { anchorEl } = this.state;

    const rootClassName = classNames(classes.root, className);

    return (
      <Fragment>
        <div className={rootClassName}>
          <Toolbar className={classes.toolbar}>
            <IconButton className={classes.menuButton} variant="text">
              {<MenuIcon />}
            </IconButton>
            <img src={logo} className={classes.logo} alt="logo" />
            <Grid
              container
              alignItems="flex-start"
              justify="flex-end"
              direction="row"
            >
              <IconButton
                aria-owns={anchorEl ? "user-menu" : undefined}
                aria-haspopup="true"
                onClick={this.handleUserMenuClick}
              >
                <UserIcon />
              </IconButton>

              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleUserMenuClose}
              >
                <MenuItem onClick={this.handleUserMenuClose}>
                  <SettingsIcon />
                  <span>Profile Settings</span>
                </MenuItem>
                <MenuItem onClick={this.handleUserMenuClose}>
                  <InputIcon />
                  <span>Logout</span>
                </MenuItem>
              </Menu>
            </Grid>
          </Toolbar>
        </div>
      </Fragment>
    );
  }
}

Topbar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(HeaderStyles)(Topbar);
